import { render } from "./Example.vue?vue&type=template&id=0e35a480&scoped=true&ts=true"
import script from "./Example.vue?vue&type=script&lang=ts"
export * from "./Example.vue?vue&type=script&lang=ts"

import "./Example.vue?vue&type=style&index=0&id=0e35a480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e35a480"]])

export default __exports__